// ==============================|| OVERRIDES - BODY ||============================== //

export default function Body() {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFeatureSettings: '"salt"',
          // Brand-teal accent for native controls (date/time pickers, checkboxes,
          // radios, range) — turns Chrome's default blue into the Ops Deck teal.
          // `accent-color` inherits, so this cascades to every input.
          accentColor: '#0E9498'
        }
      }
    }
  };
}
